export default {
    'validation.maxlength': '此欄位不得超過 {length} 個字元',
    'validation.minlength': '此欄位必須至少 {length} 個字元',
    'validation.max': '此欄位不得超過 {length} ',
    'validation.min': '此欄位必須至少 {length} ',
    'validation.gte': '必須大於或等於{value}',
    'validation.lte': '必須小於或等於{value}',
    'validation.gt': '必須大於{value}',
    'validation.lt': '必須小於{value}',
    'validation.required': '此欄位為必填',
    'validation.email': '請輸入有效的電子郵件地址',
    "validation.phone.not_valid": "無效的電話號碼",
    'validation.numeric': '請輸入有效的數字',
    'validation.date': '請輸入有效的日期',
    'validation.url': '請輸入有效的網址',
    'validation.mismatch': '值不匹配',
    'validation.invalid_selection': '請選擇有效的選項',
    'validation.serial_number_not_valid': '此序號無效',
    'validation.upload_file_size_lt': '{filename} 應該小於 {size} {unit}',
    'validation.upload_file_not_allowed_types': '{filename} 不是允許的文件類型',
    'validation.upload_file_success': '{filename} 上傳成功',
    'validation.upload_file_fail': '{filename} 上傳失敗',
    'validation.upload_len': '請上傳文件',
    'validation.records': '請選擇記錄',
    "validation.delete.items": "{value} items deleted",
}
